<template>
  <div class="container page" style="background: linear-gradient(180deg, #ffeef7 0%, #f5f0ff 100%);">
    <van-nav-bar :title="this.videoInfo.vod_name" class="nav-bar" style="background: transparent;">
      <template #left>
        <van-icon name="arrow-left" color="#000" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="movie-video">
      <video id="my-video" class="video-js"></video>
    </div>
    <div class="movie-content">
      <div class="movie-descript">
<!--        <p>{{ this.videoInfo.vod_name }}</p>-->
        <span>{{ this.videoInfo.count }}{{ $t("video.num_play") }}</span>
      </div>

      <div class="movie-body">
        <div class="movie-title">
          <div>
            <span>{{ $t("index.recmonmand") }}</span>
          </div>
        </div>
      </div>
      <div  class="hotlist">
        <div  v-for="(v,key) in moreVideoInfo" :key="key" @click="toPlayVideo(v.id)">
          <img

            :src="v.vod_pic"
          />
<!--          <div >-->
<!--            <span >{{ v.vod_name }}</span>-->
<!--            <span >{{$t("video.play")}}:{{ v.count }}</span>-->
<!--          </div>-->
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import videojs from "video.js";
import "videojs-contrib-hls";
export default {
  data() {
    return {
      nowPlayVideoUrl: "",
      cover: "",
      userInfo: [],
      videoInfo: {},
      moreVideoInfo: {},
      player: null,
      is_play: false,
      times: null,
      is_see: 0,
      vipLevel: 0,
      lastPromptTime: -1, // 记录上次弹窗时的播放时间
      trialSeconds: 10, // 非VIP用户试看秒数
    };
  },
  methods: {
    back() {
      this.$router.push({ path: "/Video" });
    },
    getVideoInfo() {
      this.$http({
        method: "get",
        data: { id: this.$route.query.id },
        url: "video_get_info",
      }).then((res) => {
        this.videoInfo = res.data;
        this.nowPlayVideoUrl = this.videoInfo.vod_play_url;
        this.cover = this.videoInfo.vod_pic;
        let videos = document.getElementById("my-video");

        videos.poster = this.cover;
        this.getVideo();
      });
    },
    toPlayVideo(id) {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
      } else {
        this.$router.push({ path: "?id=" + id });
        location.reload();
      }
    },
    getMoreVideoItem() {
      this.$http({
        method: "get",
        url: "video_get_more_item",
      }).then((res) => {
        this.moreVideoInfo = res.data;
      });
    },
    getVideo() {
      // this.player = videojs("my-video",  {
      //   height:"200px",
      //   preload: "auto", // 预加载
      //   controls: true,  // 显示播放的控件
      //   multipleArray: [0.75, 1, 1.5, 2], // 倍速设置
      // });
      this.player.src([
        {
          src: this.nowPlayVideoUrl,
          type: "application/x-mpegURL", // 告诉videojs,这是一个hls流
        },
      ]);
      this.player.poster(this.cover);

    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.is_see = this.userInfo.is_see;
          this.vipLevel = this.userInfo.vip || 0;
          if (this.userInfo.status !== 1) {
            this.$toast(this.$t("video.account_out"));
            localStorage.clear();
            this.$router.push({ path: "/Login" });
          } else {
            if (this.$store.getters.getBaseInfo.isplay == 1) {
              this.getVideoInfo();
              this.getMoreVideoItem();
              // if(this.userInfo.money <= "0.00"){
              //   this.$toast(this.$t("video.buy"));
              //   this.$router.push({path:'/Home'})
              // }
            } else {
              this.getVideoInfo();
              this.getMoreVideoItem();
            }
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    showVipPrompt() {
      this.$dialog.confirm({
        title: this.$t("video.vip_required_title"),
        message: this.$t("video.vip_required_message"),
        confirmButtonText: this.$t("common.confirm"),
        cancelButtonText: this.$t("common.cancel"),
        closeOnClickOverlay: false, // 禁止点击遮罩关闭
        className: 'vip-dialog', // 添加自定义类名
        width: '85%',
        messageAlign: 'center',
      }).then(() => {
        // 点击确定跳转到客服页面
        const service = this.$store.getters.getBaseInfo;
        if (service && service.iskefu == 1 && service.kefu) {
          window.location.href = service.kefu;
        } else {
          this.$router.push('/ServiceOnline');
        }
      }).catch(() => {
        // 点击取消也保持暂停状态,继续显示提示
        if (this.player) {
          this.player.pause();
        }
      });
    },
  },
  mounted() {
    const _this = this;
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {

        this.player = videojs(
          "my-video",
          {
            height: "200px",
            preload: "auto", // 预加载
            controls: true, // 显示播放的控件
            multipleArray: [0.75, 1, 1.5, 2], // 倍速设置
          },
          function () {
            // 视频元数据加载完成后立即设置起始时间，避免显示广告画面
            this.on("loadedmetadata", () => {
              this.currentTime(30);
            });

            this.on("play", () => {
              _this.is_play = true;
            });

            // 监听进度条拖动事件
            this.on("seeking", () => {
              const ct = this.currentTime();
              const actualTime = ct - 30;

              // 非VIP用户不能拖动到试看时间之后
              if (_this.vipLevel === 0 && actualTime > _this.trialSeconds) {
                this.currentTime(30 + _this.trialSeconds); // 限制在跳过时间+试看时间
                _this.player.pause();
                // 如果播放时间跟上次弹窗时不同，重新弹窗
                if (_this.lastPromptTime !== ct) {
                  _this.lastPromptTime = ct;
                  _this.showVipPrompt();
                }
              }
            });
          }
        );

      this.getUserInfo();
      this.times = setInterval(() => {
        if (this.player) {
          const ct = Math.round(this.player.currentTime());
          // 从30秒开始算，30+试看秒数时检查VIP
          const actualTime = ct - 30; // 减去跳过的30秒

          // VIP等级大于0可以观看全部
          if (this.vipLevel > 0) {
            return;
          }

          // 非VIP用户，播放到试看时间后显示提示
          if (actualTime >= this.trialSeconds) {
            this.player.pause();
            // 如果播放时间跟上次弹窗时不同，重新弹窗
            if (this.lastPromptTime !== ct) {
              this.lastPromptTime = ct;
              this.showVipPrompt();
            }
            return;
          }
        }
      }, 1000);
    }
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
      this.player = null;
    }
    if (this.is_play) {
      this.is_play = false;
    }
    clearInterval(this.times);
  },
};
</script>

<style scoped lang="less">
.nav-bar ::v-deep .van-nav-bar__title {
  color: #333;
}
.video-js {
  width: 100%;
  /*height: 420px;*/
  font-size: 24px;
}
.movie-content {
  flex: 1;
  overflow-y: auto;
}
.movie-content .movie-descript {
  width: 100%;
  /* height: 140px; */
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding: 15px;
}
.movie-content .movie-descript p {
  font-size: 30px;
  font-weight: 700;
  color: rgb(62, 33, 134);
}
.movie-content .movie-descript span {
  color: rgb(170, 45, 220);
  font-size: 0.8rem;
  background: rgb(242, 242, 245);
  padding: 10px;
  border-radius: 16px;
}
.movie-content .movie-body {
  width: calc(100% - 20px);
  margin: 0 auto;
}
::v-deep .movie-video .video-js .vjs-big-play-button {
  top: 50%;
  left: 50%;
  margin-top: -50px;
  margin-left: -100px;
}
.movie-content .movie-body .movie-title {
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.movie-content .movie-body .movie-title > div:first-child {
  width: 410px;
}
.movie-content .movie-body .movie-title > div:first-child span {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 30px;
  font-weight: 700;
  color: #000;
}
.movie-content .movie-body .movie-title > div:first-child span:before {
  content: "";
  display: block;
  width: 8px;
  height: 30px;
  background-color: #7e5678;
  border-radius: 25px;
  margin-right: 10px;
}

abbr,
address,
article,
aside,
audio,
b,
blockquote,
body,
canvas,
caption,
cite,
code,
dd,
del,
details,
dfn,
div,
dl,
dt,
em,
fieldset,
figcaption,
figure,
footer,
form,
h1,
h2,
h3,
h4,
h5,
h6,
header,
hgroup,
html,
i,
iframe,
img,
ins,
kbd,
label,
legend,
li,
mark,
menu,
nav,
object,
ol,
p,
pre,
q,
samp,
section,
small,
span,
strong,
sub,
summary,
sup,
table,
tbody,
td,
tfoot,
th,
thead,
time,
tr,
ul,
var,
video {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  font-size: 100%;
  vertical-align: baseline;
  box-sizing: border-box;
}

.vjs-big-play-button .vjs-icon-placeholder {
  font-size: 1.63em !important;
}
.hotlist{
  display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.hotlist div{
  position: relative;
    width: calc(50% - 10px);
    border-radius: 16px;
    overflow: hidden;
    margin-bottom: 25px;
}
.hotlist div img{
  width: 100%;
  height: 27vw;
}
.hotlist div div{
  position: absolute;
    bottom: 20px;
    width: 100%;
    left: 0;
    background: rgba(0, 0, 0, .4);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 3vw;
    height: 8vw;
    border-radius: 16px;
}
.hotlist div div span{
  width: 50%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
    padding-left: 20px;
}

</style>

<style lang="less">
/* VIP弹窗全局样式 */
.vip-dialog {
  width: 80% !important;
  max-width: 600px !important;
  border-radius: 20px !important;
  overflow: hidden !important;
}

.vip-dialog .van-dialog__header {
  font-size: 36px !important;
  font-weight: bold !important;
  padding: 45px 30px 20px !important;
  color: #7e5678 !important;
  text-align: center !important;
}

.vip-dialog .van-dialog__message {
  font-size: 28px !important;
  line-height: 1.8 !important;
  padding: 30px 40px 45px !important;
  color: #333 !important;
  text-align: left !important;
}

.vip-dialog .van-dialog__footer {
  padding: 0 !important;
  overflow: hidden !important;
}

.vip-dialog .van-hairline--top::after {
  border-top-width: 2px !important;
}

.vip-dialog .van-dialog__footer .van-button {
  height: 100px !important;
  font-size: 30px !important;
  font-weight: bold !important;
  border-radius: 0 !important;
  flex: 1 !important;
}

.vip-dialog .van-dialog__cancel {
  color: #999 !important;
  background: #f5f5f5 !important;
  border: none !important;
}

.vip-dialog .van-dialog__confirm {
  background: linear-gradient(90deg, #d51aac, #d63f8c) !important;
  color: #fff !important;
  border: none !important;
}
</style>
